import $ from 'jquery';
import abTastySvc from './guAbTastySvc';
import Logger from './common/safe-log';
import SimpleObserver from './common/observer';
import 'ua-parser-js';
import { guLocalStorage, timestampTxt } from './lib/utils';

const GU_EXP_EVENTS = {
    READY: 'ready',
    MODIFICATIONS_ACTIVE: 'MODIFICATIONS_ACTIVE',
    UPDATED_CONTEXT: 'UPDATED_CONTEXT',
};

const GuExperiment = {
    fsInstance: null,
    isFsInstanceReady: false,
    isModificationActive: false,
    fireEventsQueue: [],
    observer: new SimpleObserver(),
    init() {
        Logger.debug(`${timestampTxt()} - Begin initialization of Experimentation`);
        this.initUserAttributes();
        this.fsInstance = abTastySvc.init(window.gu_ua);
        this.initEventHandlers();
        this.initExperimentationPlatform();
        Logger.debug(`${timestampTxt()} - Finished initialization of Experimentation`);
        this.observer.notify(GU_EXP_EVENTS.READY);
    },
    initEventHandlers() {
        try {
            this.observer.subscribe(GU_EXP_EVENTS.MODIFICATIONS_ACTIVE, () => {
                this.fireEventsQueue.forEach(evt => this.fireEvent(evt, false));
            });

            GuExperiment.fsInstance.on('ready', function () {
                GuExperiment.isFsInstanceReady = true;
            });
        } catch (error) {
            Logger.error(`${timestampTxt()} - Failed to initialize handlers initEventHandlers()`, error);
        }
    },
    initUserAttributes: function() {
        try {
            window.gu_ua = {};
            const userId = window.gu_qs.req_id !== undefined ? window.gu_qs.req_id : window.uuidv4();
            let pagepath = document.location.pathname;
            let page     = pagepath.slice(1, -1);
            let fullurl  = document.location.href;
            let doc_ref  = document.referrer.split('/');

            if (window.gu_qs) {
                window.gu_ua.transactionId = window?.gu_payments?.order.order?.name;
                window.gu_ua.aff_id        = window.gu_qs.aff_id !== undefined ? window.gu_qs.aff_id : '';
                window.gu_ua.req_id        = window.gu_qs.req_id !== undefined ? window.gu_qs.req_id : '';
                window.gu_ua.cpa           = window.gu_qs.cpa !== undefined ? window.gu_qs.cpa : '';
                // window.gu_ua.offer         = window.gu_qs.offer !== undefined ? window.gu_qs.offer : '';
                window.gu_ua.country       = window.gu_qs.gucountry !== undefined ? window.gu_qs.gucountry : '';
                window.gu_ua.language      = window.gu_qs.gulanguage !== undefined ? window.gu_qs.gulanguage : '';
                window.gu_ua.city          = window.gu_qs.city !== undefined ? window.gu_qs.city : '';
                window.gu_ua.currency      = window.gu_qs.gucurrency !== undefined ? window.gu_qs.gucurrency : '';
                window.gu_ua.lpid          = window.gu_qs.lpid !== undefined ? window.gu_qs.lpid : '';
                window.gu_ua.gudtc         = window.gu_qs.gudtc !== undefined ? window.gu_qs.gudtc : '';
                window.gu_ua.referrer_url  = document.referrer;
                window.gu_ua.referrer_page = document.referrer !== '' ? doc_ref[3] : '';
                window.gu_ua.offer         = window.site_vars.gu_offer_url !== undefined ? window.site_vars.gu_offer_url : '';
                window.gu_ua.guvariation   = window.gu_qs.guvariation !== undefined ? window.gu_qs.guvariation : '';
                window.gu_ua.gulayout      = window.gu_qs.gulayout !== undefined ? window.gu_qs.gulayout : '';
                window.gu_ua.fbclid        = window.gu_qs.fbclid !== undefined ? window.gu_qs.fbclid : '';
                window.gu_ua.gclid         = window.gu_qs.gclid !== undefined ? window.gu_qs.gclid : '';
                window.gu_ua.wbraid        = window.gu_qs.wbraid !== undefined ? window.gu_qs.wbraid : '';
                window.gu_ua.gulang        = window.gu_qs.gulang !== undefined ? window.gu_qs.gulang : '';
                window.gu_ua.city          = window.gu_qs.city !== undefined ? window.gu_qs.city : '';
                window.gu_ua.region        = window.gu_qs.region !== undefined ? window.gu_qs.region : '';

            }

            /**
             * We need to handle domain a little differently because of subdomains
             */
            let domain = '';
            let domainparts = document.location.hostname.split('.');

            if (domainparts.length === 3) {
                domain = domainparts.shift();
                domain = domainparts.join('.');
            } else {
                domain = document.location.hostname;
            }

            window.gu_ua.user_agent = navigator.userAgent;
            window.gu_ua.userId = userId;

            window.gu_ua.browser = $?.ua?.browser?.name?.toLowerCase?.();
            window.gu_ua.browser_version = $?.ua?.browser?.version;
            window.gu_ua.device_type = $?.ua?.device?.type?.toLowerCase?.() || 'desktop';
            window.gu_ua.device_model = $?.ua?.device?.model?.toLowerCase?.() || 'desktop';
            window.gu_ua.device_vendor = $?.ua?.device?.vendor?.toLowerCase?.() || 'desktop';
            window.gu_ua.os = $?.ua?.os?.name?.toLowerCase?.();
            window.gu_ua.os_version = $?.ua?.os?.version;

            window.gu_ua.page = page;
            window.gu_ua.url = fullurl;
            window.gu_ua.domain = domain;
            window.gu_ua.selected_bundle_id = '';
            window.gu_ua.selected_bundle_position = '';
            window.gu_ua.selected_upsell_ids = '';

        } catch (e) {
            Logger.error('Failed to initialize User Attributes', e);
        }
    },
    initExperimentationPlatform: function () {
        try {
            GuExperiment.fsInstance.on('ready', function () {
                // qs1 - 9
                const modificationOptions = [
                    {
                        key: 'qs1', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs2', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs3', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs4', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs5', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs6', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs7', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs8', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs9', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'qs10', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect1', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect2', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect3', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect4', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect5', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect6', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect7', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect8', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect9', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                    {
                        key: 'redirect10', // required
                        defaultValue: '', // required
                        activate: true,
                    },
                ];

                const variations = GuExperiment.fsInstance.getModifications(modificationOptions);
                GuExperiment.isModificationActive = true;
                GuExperiment.observer.notify(GU_EXP_EVENTS.MODIFICATIONS_ACTIVE);

                if (window['guEEQ'] && window['guEEQ'].length > 0) {
                    for (let i = 0; i < window['guEEQ'].length; i++) {
                        GuExperiment.fireEvent(window['guEEQ'][i])
                    }
                    window['guEEQ'] = []
                }

                GuExperiment.initExperiments(variations);

                let findmodID = GuExperiment.fsInstance.fetchedModifications
                Logger.info('guExperiments modificationId', findmodID);
                findmodID.forEach((item) => Logger.debug(`Modification ID:${item.variation.id}`));
            });
        } catch (e) {
            Logger.error('Failed to initialize experimentation platform', e);
        }
    },
    initExperiments: function (variations) {
        try {
            console.log(variations);
            let check_qs = '';
            let check_redirect = '';
            let winUrl;
            for (const variation_key in variations) {
                if (variation_key.includes('qs')) {
                    check_qs = `${variations[variation_key]}`;

                    if (check_qs.length > -1 && check_qs !== '') {
                        console.log(`${variations[variation_key]}`);
                        let get_qs = check_qs.split('=');
                        let qs_key = get_qs[0];
                        let qs_val = get_qs[1];

                        console.log('checking flagship', qs_key);
                        if (check_qs.indexOf(qs_key) > -1) {
                            window.gu_ua[qs_key] = qs_val;
                            if (!window.gu_qs[qs_key]) {
                                window.gu_qs[qs_key] = qs_val;
                            }
                        }
                    }
                }

                if (variation_key.includes('redirect')) {
                    check_redirect = `${variations[variation_key]}`;
                    winUrl = window.location.href;
                    const winUrlContainsRedirect = winUrl.includes(check_redirect)
                    if (check_redirect !== '' && check_redirect.length > -1 && !winUrlContainsRedirect) {
                        console.log('found a redirect',`${variations[variation_key]}`);
                        guLocalStorage(check_redirect, winUrl)
                        window.location.href = check_redirect + document.location.search;
                    } else {
                        this.updatePersona();
                    }
                }
            }

            $(function ($) {
                $(document).ready(function () {
                    $('.cta-button').on('click', function () {
                        console.log('did it click');
                        let selectedBundle                    = $(this);
                        window.gu_ua.selected_bundle_position = selectedBundle.parent().parent().attr('data-index');
                        GuExperiment.updatePersona();
                    });

                    $('#offer .bundle, .additional-offer .bundle').click(function () {
                        let selectedBundle = $(this);
                        console.log('clicked it');
                        window.gu_ua.selected_bundle_id = selectedBundle[0].id;
                        GuExperiment.updatePersona();
                    });

                    let upsellArray = [];

                    $('.upsell .button').on('click', function () {
                        let selectedUpsell = $(this).parents('div');
                        let findParent     = selectedUpsell.find('.upsell');
                        let findid         = findParent[0].id;
                        upsellArray.push(findid);

                        GuExperiment.updatePersona();
                    });

                    $('.upsell-popup .button').on('click', function () {
                        let selectedUpsell = $(this).parents('div');
                        let findParent = selectedUpsell.find('.upsell-popup');
                        let findId = findParent[0].id;

                        upsellArray.push(findId);
                        console.log(upsellArray);
                        GuExperiment.updatePersona();
                    });

                    // handle size variants differently
                    const waitForEl = function (selector, callback) {
                        if ($(selector).length) {
                            callback();
                        } else {
                            setTimeout(function () {
                                waitForEl(selector, callback);
                            }, 100);
                        }
                    };

                    waitForEl('#addon-modal', function () {
                        $('#addon-modal .cta-green').on('click', function () {
                            // console.log('did this run');
                            let selectedUpsell = $(this).parents('div');
                            let findParent = selectedUpsell.find('#addon-modal');
                            let findId = findParent[0].id;

                            upsellArray.push(findId);
                            console.log(upsellArray);
                            GuExperiment.updatePersona();
                        });

                    });

                    // Observe when the checkout is open.
                    let targetNode = document.getElementById('checkout');

                    if (targetNode) {
                        let observer = new MutationObserver(function () {
                            if (targetNode.style.display !== 'none') {
                                window.gu_ua.selected_upsell_ids = upsellArray.toString();
                                observer.disconnect();
                            }
                        });
    
                        observer.observe(targetNode, {attributes: true, childList: true});
                    }
                });
            });
        } catch (e) {
            Logger.error('Failed to initialize experiment', e);
        }
    },
    fireEvent: function (event, addToRetryQueueIfNotReady = true) {
        try {
            const readyToSenHit = (this.isFsInstanceReady && this.isModificationActive);
            if (!readyToSenHit) {
                Logger.warn('GuExperiment - Called fire event before activate flags');
                if (addToRetryQueueIfNotReady) this.fireEventsQueue.push(event);
                return;
            }
            
            Logger.info('guExperiments fireEvent()');
            GuExperiment.fsInstance.sendHit({ type: 'Event', data: event });
        } catch (e) {
            Logger.error('Failed while sending event to experimentation', e);
        }
    },
    updatePersona: async function () {
        try {
            GuExperiment.initUserAttributes();
            guLocalStorage(null, null, window.gu_ua.userId, true)
            GuExperiment.fsInstance.updateContext(window.gu_ua);
            const statusCode = await GuExperiment.fsInstance.synchronizeModifications().catch(err => {
                Logger.error('Failed synchronizeModifications()', err);
            });

            Logger.debug(`${timestampTxt()} - synchronizeModifications responded with status code:${statusCode}`);
        } catch (ex) {
            Logger.error('Failed updating user context.', ex);
        }
    },
    subscribe(event, fn) {
        this.observer.subscribe(event, fn);
    }
};

// Kick off experiment
GuExperiment.init();

window.guExperiment = GuExperiment;
export default GuExperiment;
